/*
 * @Author       : Zhelin Cheng
 * @Date         : 2021-11-05 15:46:51
 * @LastEditors  : 程哲林
 * @LastEditTime : 2024-04-16 13:48:55
 * @FilePath     : /marketing-introduce-ssr/common/const.ts
 * @Description  : 未添加文件描述
 */

import * as jojoConstConfig from './jojoConst';
import * as jojoupConstConfig from './jojoupConst';
import * as matrixConstConfig from './matrixConst';
import { dashedEnvPath, getAppName, getEnvName } from './utils';
// 判断是不是浏览器环境
export const isBrowser = process.browser;
// 全局变量通过define-plugin注入
const envDebug = process.env.ENV_DEBUG; // 本地调试

export const envName = getEnvName(); // 环境变量
export const appName = getAppName(); // 应用名

export const { envPath } = jojoConstConfig;

export const isNodeServer = process.env.BUILD_TYPE === 'node';

export const isMatrix = appName === 'matrix';
export const isJoJoUp = appName === 'jojoup';

type JojoConstConfigKey = keyof typeof jojoConstConfig;
type MatrixConstConfigKey = keyof typeof matrixConstConfig;
type JojoUpConstConfigKey = keyof typeof jojoupConstConfig;

const appConst = (name: JojoConstConfigKey | MatrixConstConfigKey | JojoUpConstConfigKey): any => {
  if (isJoJoUp) return jojoupConstConfig[name as JojoUpConstConfigKey] || '';
  return isMatrix
    ? matrixConstConfig[name as MatrixConstConfigKey] || ''
    : jojoConstConfig[name as JojoConstConfigKey] || '';
};

export const isMock = process.env.ENV_MOCK === 'true';

// 是否调试模式，区别非正式环境
export const DEBUG = !!envName && envName !== 'pro';
// 是否开启本地调试
export const DEBUG_LOCAL = envDebug;

// 模拟调试header信息，跳过授权检测
export const DEBUG_HEADER_INFO = envDebug
  ? {
      // 'X-UAGW-userId': 642693, // dev
      // 'X-UAGW-userId': 200541606, // fat
      'X-UAGW-userId': 200918671, // fat
      'X-UAGW-authMode': 1
    }
  : {};

// api接口相关
export const CASHBACK_BASE_URL = appConst('CASHBACK_BASE_URL');
export const UC_API_DOMAIN = appConst('UC_API_DOMAIN');
export const TRACE_BASE_URL = appConst('TRACE_BASE_URL');
export const TINMAN_BASE_URL = appConst('TINMAN_BASE_URL');
export const TINMAN_BASE_C_URL = appConst('TINMAN_BASE_C_URL');
export const MALL_BASE_URL = appConst('MALL_BASE_URL');
export const PAY_BASE_URL = appConst('PAY_BASE_URL');
export const WEBSITE_URL = appConst('WEBSITE_URL');
export const ORDER_BASE_URL = appConst('ORDER_BASE_URL');

export const MALL_ADDRESS_LIST = appConst('MALL_ADDRESS_LIST');
export const MALL_ORDER_LIST = appConst('MALL_ORDER_LIST');
export const MALL_ORDER_DETAIL = appConst('MALL_ORDER_DETAIL');
export const EDU_POINTS = appConst('EDU_POINTS');
export const EDU_TOKEN = appConst('EDU_TOKEN');

// 装扮跳转 scheme（APP 内"我的装扮"页）
export const MY_DRESS_SCHEME = 'tinman-router://cn.tinman.jojoread/flutter/space/mydress';

// 推荐礼跳转链接统一 Apollo 配置 key（JSON 字符串：{ userPointIntroUrl, dressIntroUrl }）
export const RECOMMEND_GIFT_INTRO_APOLLO_KEY = 'recommendGift.introUrl';

// 非 APP 环境装扮提示文案
export const DRESS_NON_APP_TIP = '新装扮已发放至您账户，在叫叫APP学习页，点击顶部个人形象可换装哦';

// 抽奖的填地址
export const ACT_ADDRESS = appConst('ACT_ADDRESS');
// 打开APP地址
export const OPEN_APP = appConst('OPEN_APP');
// 邀请明细的填地址
export const Price_ADDRESS = appConst('Price_ADDRESS');
// 专辑详情页
export const READ_HUB = appConst('READ_HUB');

// 包名
export const PACKAGE_NAME = appConst('PACKAGE_NAME');

// 授权失效之后进入链接地址
export const AUTH_SIGN_URL = appConst('AUTH_SIGN_URL');
export const AUTH_REDIRECT_PARAMS = appConst('AUTH_REDIRECT_PARAMS');

// 新的微信授权接口
export const AUTH_SIGN_URL_NEW = appConst('AUTH_SIGN_URL_NEW');

// 非静默登陆登陆也
export const AUTH_INPUT_LOGIN = appConst('AUTH_INPUT_LOGIN');

export const SENSORS_SERVER_URL = appConst('SENSORS_SERVER_URL');

export const names = [
  '枯藤',
  '嗟梦心海',
  '甜蜜大泛滥',
  '凉心初透',
  '爽妹',
  '把酒祝东风',
  '生死皆闲事',
  '沐年之夏',
  'Hecate',
  '红薇染露',
  '执扇琅珠',
  '梦离旧时光',
  '退场',
  '叶舞翩翩',
  '烂故事',
  '旧故',
  '久醉绕心弦',
  '浮生醉清风',
  '不与君同',
  '吞咽沧桑',
  '梦罢',
  '晚巷',
  '夏朽暖栀',
  '旧茶',
  '羡鱼'
];

export const MINI_INFO =
  envName === 'pro' || envName === 'uat'
    ? {
        userName: 'gh_ef0f0e30ef89', // 正式小程序id
        miniProgramType: 0,
        miniProgram: 'jojo_read'
      }
    : {
        userName: 'gh_87f2400c676b', // 测试小程序id
        miniProgramType: 2,
        miniProgram: 'jojo_haoxiguan'
      };

export const DEFAULT_HEAD_PIC = '/static/images/default_head_pic.png';

export const PLACEHOLDER_MAP = appConst('PLACEHOLDER_MAP');

export const SERVICE_URL = appConst('SERVICE_URL');

export const SCHEMA_MAP = [
  {
    app: '叫叫阅读',
    schema: 'tinman-router://cn.tinman.jojoread',
    home: '/home/course',
    downloadUrl: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.shusheng.JoJoRead'
  },
  {
    app: '叫叫老识字（叫叫识字）',
    // 没有，直接调用阅读的
    schema: 'tinman-router://cn.tinman.jojoread',
    downloadUrl: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.tinmanarts.JoJoSherlock'
  },
  {
    app: '叫叫绘本',
    schema: 'anibook-router://com.jojoread.huiben',
    home: '/home/content',
    downloadUrl: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.jojoread.huiben'
  },
  {
    app: '叫叫新识字（汉字大冒险）',
    schema: 'jojosherlock-router://cn.tinman.jojosherlock',
    downloadUrl: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.jojoread.JoJoSherlock'
  },
  {
    app: '叫叫口算',
    schema: `jojocalculate-router://cn.tinman.jojocalculate`,
    downloadUrl: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.jojoread.JoJoCalculate'
  }
];

export const RECORD_KEY = 'record_key';
export const READ_BASE_URL = appConst('READ_BASE_URL');

const jojoAccountConfigEnum = {
  jojo: { envName },
  matrix: {
    envName,
    hosts: {
      ucHost: UC_API_DOMAIN,
      serverHost: `https://jojoread${dashedEnvPath(envName)}.cdssylkj.com`,
      apiHost: UC_API_DOMAIN
    }
  },
  jojoup: {
    envName,
    hosts: {
      ucHost: UC_API_DOMAIN,
      serverHost: READ_BASE_URL,
      apiHost: UC_API_DOMAIN
    }
  }
};

export const jojoAccountConfig =
  jojoAccountConfigEnum[appName as keyof typeof jojoAccountConfigEnum] ||
  jojoAccountConfigEnum.jojo;

export enum ACT_TYPE_MAPS {
  REFERRAL = 1,
  EXTENDS = 2,
  ROUTINE = 3,
  GROUP = 4,
  INVITE_FRIENDS_TO_WIN = 5,
  RESERVE = 6,
  LOTTERY = 7
}

export const platformList = {
  1: '微信内',
  2: '微信小程序',
  3: 'APP内'
};

export const JJParentsUserName = 'gh_4766cc74fd5d'; // 叫叫家长帮手正式环境
export const JJParentsUserNameTest = 'gh_8fc2b2521b50'; // 叫叫家长帮手测试环境

// 家长端弄小程序appid
export const WX_JOJO_PARENTS = envName === 'pro' ? JJParentsUserName : JJParentsUserNameTest;

// 小程序原生海报页地址
export const WX_JOJO_PARENTS_POSTER_PAGE = '/pages/activity/activity_poster/index';

export const IS_RETAINED = '_is_retained';

export const POSTER_ZOOM = 0.352;

export const POSTER_IMG_SIZE_MAX = 150 * 1024; // ios 海报分享大于150kb，会丢复制参数 https://developers.weixin.qq.com/ ， 针对ios设备特除判断，不显示复制文案弹窗

export const BASE_PATH = process.env.ENV_BASE || '';

export const APP_HOME_PAGE = isJoJoUp
  ? 'box-router://com.read.box.book/course_home/home'
  : 'tinman-router://cn.tinman.jojoread/home/course';
export const COMMON_BASE_URL = TINMAN_BASE_URL;
export const ENV_NAME = envName;
// JOJO_APPID
export const JOJO_APPID = ENV_NAME !== 'pro' ? 'wxcfbbe4172ea27fb9' : 'wx3ab3a71978f288f4';
// JOJOUP_APPID
export const JOJOUP_APPID = ENV_NAME !== 'pro' ? 'wx7376471f4a1200ca' : 'wx9cc2917ad9da0ab1';

// 更换为铁皮人主体公众号，用于唤起deepLink
const WX_APPID_PRO = !isJoJoUp ? 'wx03ede3e498e058a5' : 'wx6050d5e375a41bc0';

export const WX_APPID: string = ENV_NAME !== 'pro' ? 'wx6bc1e63a0998b3b7' : WX_APPID_PRO;

// 下载地址非模版字符串，用于替换标识符
export const downloadUrl = !isJoJoUp
  ? 'https://jojoread.tinman.cn/account/app/${hash}/download/?packageName=com.shusheng.JoJoRead&channel=Tinman'
  : 'https://pages.mohezi.cn/read/account/app/${hash}/download?packageName=com.read.box.book';
